var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"language-select"},[_c('v-select',{staticClass:"lang-select",attrs:{"label":_vm.$t('language'),"items":_vm.localesArray,"item-text":"text","item-value":"value","value":_vm.currLocale},on:{"change":_vm.setTranslationsFor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }